import React from 'react';
import Card from '../../ui/Card';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
const ChannelSpendDistribution: React.FC = () => {
  const data = [{
    name: 'ATL (Above The Line)',
    value: 82,
    color: '#3b82f6'
  }, {
    name: 'BTL (Below The Line)',
    value: 65,
    color: '#10b981'
  }, {
    name: 'Digital',
    value: 95,
    color: '#f59e0b'
  }, {
    name: 'Trade Marketing',
    value: 48,
    color: '#8b5cf6'
  }];
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className="font-bold text-sm" data-id="element-6889">
        {`${(percent * 100).toFixed(0)}%`}
      </text>;
  };
  return <Card className="p-6" data-id="element-6890">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6891">
        Channel-wise Spend Distribution
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-6892">
        Marketing budget allocation (₹ Cr)
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-6893">
        <PieChart data-id="element-6894">
          <Pie data={data} cx="50%" cy="50%" labelLine={false} label={renderCustomizedLabel} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-6895">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-6896" />)}
          </Pie>
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `₹${value} Cr`} data-id="element-6897" />
          <Legend verticalAlign="bottom" height={36} formatter={(value, entry: any) => <span className="text-sm text-gray-700" data-id="element-6899">
                {value}: ₹{entry.payload.value} Cr
              </span>} data-id="element-6898" />
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6900">
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-6901">
          <div className="flex justify-between" data-id="element-6902">
            <span className="text-gray-600" data-id="element-6903">Total Spend</span>
            <span className="font-semibold text-gray-900" data-id="element-6904">₹{total} Cr</span>
          </div>
          <div className="flex justify-between" data-id="element-6905">
            <span className="text-gray-600" data-id="element-6906">Digital Share</span>
            <span className="font-semibold text-orange-600" data-id="element-6907">
              {(data[2].value / total * 100).toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </Card>;
};
export default ChannelSpendDistribution;